module.exports = __webpack_public_path__ + "img/red-price-bg.a5a659d6.png";